import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {type IAttributeVocabulary} from '../schema';

/**
 * `removeAttributeVocabulary` request params
 * (what is used to send to server)
 */

export type RemoveAttributeVocabularyRequestOptions = {
	id: number;
};

/**
 * `removeAttributeVocabulary` request
 * (what removes sent to the server)
 */
export type RemoveAttributeVocabularyRequest = [
	RemoveAttributeVocabularyRequestOptions['id'],
];

/**
 * `removeAttributeVocabulary` response
 * (what comes back from the server)
 */
export type RemoveAttributeVocabularyResponse = SuccessResponse<boolean>;

/**
 * `removeAttributeVocabulary` result
 * (what is utilized from the server response)
 */
export type RemoveAttributeVocabularyResult = number;

export const removeAttributeVocabularyEndpoint = 'removeAttributeVocabulary';

/**
 * Remove attribute vocabularies
 * @param fetchParams Fetch params
 */
export const removeAttributeVocabulary = async ({
	id,
}: RemoveAttributeVocabularyRequestOptions): Promise<RemoveAttributeVocabularyResult> => {
	const client = NetxQueryClient();

	const requestParams: RemoveAttributeVocabularyRequest = [id];

	return client
		.post<RemoveAttributeVocabularyResponse>(
			removeAttributeVocabularyEndpoint,
			requestParams,
		)
		.then((response) => {
			const result = getResponseResults(response);
			if (!result) throw new Error('Failed to remove attribute vocabulary');
			return id;
		});
};

export default removeAttributeVocabulary;
